import styled from 'styled-components';

export const SecondaryButton = styled.button<{
  $isFilled?: boolean;
}>`
  min-width: 300px;
  border: 4px solid ${({ theme }) => theme.colors.darkBlueV2};
  border-radius: 30px;
  font-size: 16px;
  font-weight: 700;
  line-height: 54px;
  text-transform: uppercase;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.darkBlueV2};
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0 10px 20px rgba(0 0 0 / 20%);

  ${({ theme }) => theme.breakpoints.down('md')} {
    border-width: 2px;
  }
`;
